import { render, staticRenderFns } from "./PanelElement.vue?vue&type=template&id=364e18cc&scoped=true&"
import script from "./PanelElement.vue?vue&type=script&lang=js&"
export * from "./PanelElement.vue?vue&type=script&lang=js&"
import style0 from "./PanelElement.vue?vue&type=style&index=0&id=364e18cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364e18cc",
  null
  
)

export default component.exports